import { render } from "./ui-dialog.vue?vue&type=template&id=6ab30969"
import script from "./ui-dialog.vue?vue&type=script&lang=ts"
export * from "./ui-dialog.vue?vue&type=script&lang=ts"

import "./ui-dialog.vue?vue&type=style&index=0&id=6ab30969&lang=less"
script.render = render

export default script